import classNames from 'classnames';

import MaCriticalFormItem from '../../components/ma-critical-form-item';
import s from '../../components/styles.module.scss';

import type { FormikProps } from 'formik';
import type { FC } from 'react';
import type { TFormItem } from '../../types';
import type { ICriticalReadingData } from '../types';

interface StepRendererProps {
  items: TFormItem[];
  formik: FormikProps<ICriticalReadingData>;
  /** field `name`s that are required-but-empty — the wrapper gets a red border. */
  errors?: string[];
}

/** A wrapper is in error if the item itself, or any of its (selected) descendants, is flagged. */
const hasError = (
  item: TFormItem,
  errorSet: Set<string>,
  values: ICriticalReadingData,
): boolean => {
  if ('name' in item && errorSet.has(item.name)) return true;
  if ('items' in item && item.items?.some((i) => hasError(i, errorSet, values)))
    return true;
  if ('options' in item && item.options) {
    return item.options.some(
      (opt) =>
        values[(item as { name: string }).name] === opt.value &&
        opt.subItems?.some((i) => hasError(i, errorSet, values)),
    );
  }
  return false;
};

const StepRenderer: FC<StepRendererProps> = ({
  items,
  formik,
  errors = [],
}) => {
  const errorSet = new Set(errors);
  return (
    <>
      {items.map((formItem) => (
        <div
          className={classNames(s.item, {
            [s.error]: hasError(formItem, errorSet, formik.values),
          })}
          key={formItem.key}
        >
          <MaCriticalFormItem item={formItem} formik={formik as any} />
        </div>
      ))}
    </>
  );
};

export default StepRenderer;
